import type { LucideIcon } from 'lucide-react';
import type { ReactNode } from 'react';
import { cx } from '../cx.js';

export interface EmptyStateProps {
  icon?: LucideIcon;
  title: string;
  /** Spiega cosa fare per riempire l'elenco. */
  children?: ReactNode;
  action?: ReactNode;
  className?: string;
}

/** Stato vuoto di un elenco o di una tabella. */
export function EmptyState({ icon: Icon, title, children, action, className }: EmptyStateProps) {
  return (
    <div className={cx('rounded-lg border border-dashed border-border p-8 flex flex-col items-center text-center gap-3', className)}>
      {Icon && <Icon aria-hidden size={32} strokeWidth={1.75} className="text-ink-muted" />}
      <p className="t-title-3">{title}</p>
      {children && <p className="t-body text-ink-muted max-w-[48ch]">{children}</p>}
      {action && <div className="pt-2">{action}</div>}
    </div>
  );
}
